<template>
  <div class="i-career-actions">
    <template v-if="GlobalFunctions.isExtendedRecommendedJobType(activeJob) && showJobFeedback && activeJob">
      <iFavoriteJob
        class="action"
        :job-id="activeJob.id"
        :is-favorite="activeJob.isFavorite"
      />
      <iNewCareers class="action" />
      <iRemoveJob
        class="action"
        :job-id="activeJob.id"
        :job-title="activeJob.title"
      />
    </template>
    <iDownloadPdf class="action" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useReportStore } from "@/stores/report"
import { useUserStore } from "@/stores/user"

import { GlobalFunctions } from "@/helpers/globalFunctions"

import iDownloadPdf from "@/components/global/DownloadPdf.vue"
import iFavoriteJob from "@/components/report/careers/FavoriteJob.vue"
import iRemoveJob from "@/components/report/careers/RemoveJob.vue"
import iNewCareers from "@/components/report/careers/NewCareers.vue"

// STORES AND COMPOSABLES
const reportStore = useReportStore()
const userStore = useUserStore()

// COMPUTED
const activeJob = computed(() => reportStore.getActiveJob)

const showJobFeedback = computed(() => {
  return (
    GlobalFunctions.isExtendedRecommendedJobType(activeJob.value) &&
    !!activeJob.value?.id &&
    !!activeJob.value?.title &&
    !activeJob.value?.isCurrentJob &&
    !activeJob.value?.isActivelyExploringJob &&
    !activeJob.value?.isSampleJob &&
    !userStore.isTierFree
  )
})
</script>

<style lang="scss" scoped>
.i-career-actions {
  @include flex(row, $justify: center, $align: center, $gap: 0);
  @include border-radius-md;

  border: 1px solid $zumthor100;
  width: 100%;
  margin: 25px 0 35px;
  position: relative;
}
</style>

<style lang="scss">
.i-career-actions {
  .pad-wrap {
    padding: 0;
    width: 100%;
    cursor: pointer;

    @media screen and (min-width: $breakpoint-sm) {
      padding: 15px 0;
    }

    &:hover {
      background-color: $azure-radiance50;
    }
  }

  .pad-wrap > a {
    width: 100%;
    padding: 8px 5px;

    @media screen and (min-width: $breakpoint-sm) {
      padding: 5px;
    }
  }

  .action:not(:nth-last-child(1 of .action)).pad-wrap > a,
  .action:not(:nth-last-child(1 of .action)) .pad-wrap > a {
    border-right: 1px solid $zumthor100;
  }
}
</style>
